import classNames from 'clsx';
import { camelCase } from 'lodash';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import InfoIcon from '../../../../../assets/icons/pr-info.svg';
import useCardDetails from '../../../../hooks/useCardDetails';

import styles from './Card.scss';
import AdditionalDetails from './components/AdditionalDetails/AdditionalDetails';

export type Variant = 'StandardSotd' | 'BonusRounds' | 'PowerPath';

export interface Props {
  disabled?: boolean;
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  label?: string;
  variant: Variant;
  totalSpins?: number;
  expiryTime?: number;
}

const Card: React.FC<Props> = ({
  disabled = false,
  variant,
  onClick,
  label = '',
  totalSpins,
  expiryTime
}) => {
  const classname = styles[camelCase(variant) as keyof typeof styles];
  const { title, description, infoTag, hasImage } = useCardDetails(disabled, variant);
  const isSotd = totalSpins && expiryTime;

  return (
    <div
      className={classNames(styles.container, classname, {
        [styles.disabled]: disabled
      })}
      {...(!disabled && {
        onClick,
        tabIndex: 0,
        role: 'button',
        'aria-label': label
      })}
    >
      <div className={styles.textContainer}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.description}>{description}</p>
        {!disabled && isSotd && (
          <AdditionalDetails totalSpins={totalSpins} expiryTime={expiryTime} />
        )}
      </div>
      {hasImage && <div className={classNames(styles.imageContainer)} />}
      <ResolverLink className={styles.info} resolverTag={infoTag}>
        <InfoIcon />
      </ResolverLink>
    </div>
  );
};

export default Card;
